import React from 'react';

const FormBox = ({ children, title, style, className }) => {
  return (
    <div
      className={`form-box${className ? ` ${className}` : ''}`}
      style={{ ...style }}
    >
      {title && (
        <div className="form-box-title">
          <strong>{title}</strong>
        </div>
      )}
      {children}
    </div>
  );
};

export default FormBox;
